import {GET_ACCOUNTS,GET_LOGS,ADD_ACCOUNTS,DEL_ACCOUNTS,UPDATE_ACCOUNT,DISABLE_ACCOUNTS,RESET_ACCOUNTS,ACCOUNT_ERROR,CLEAR_ERRORS,CLEAR_SECRETS,IN_PROGRESS,SET_STARTTIME,CLEAR_STARTTIME,FILTER_LOGS,CLEAR_LOGFILTER,FILTER_ACCOUNTS,CLEAR_ACCOUNTFILTER} from './teachTypes';
import axios from 'axios';

export const getAccounts = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/teach');
    dispatch({type: GET_ACCOUNTS, payload: res.data});
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const getLogs = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/teach/logs');
    dispatch({type: GET_LOGS, payload: res.data});
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const addAccounts = (account) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    dispatch({type: IN_PROGRESS});
    const res = await axios.post('/api/teach', account, config);
    dispatch({type: ADD_ACCOUNTS, payload: res.data});
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const delAccounts = (id) => async (dispatch) => {
  try {
    dispatch({type: IN_PROGRESS});
    const res = await axios.delete(`/api/teach/${id}`);
    dispatch({type: DEL_ACCOUNTS, payload: res.data});
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const updateAccount = (id,formData) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    dispatch({type: IN_PROGRESS});
    const res = await axios.put(`/api/teach/uid/${id}`, formData, config);
    dispatch({type: UPDATE_ACCOUNT, payload: res.data});
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const enableAccounts = (id,enable) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    dispatch({type: IN_PROGRESS});
    const res = await axios.put(`/api/teach/course/${id}`, enable, config);
    if(enable.enable){
      dispatch({type: RESET_ACCOUNTS, payload: res.data});
    }else{
      dispatch({type: DISABLE_ACCOUNTS, payload: res.data});
    }
  } catch (err) {
    dispatch({type: ACCOUNT_ERROR, payload: err.response.data.msg});
  }
};

export const clearErrors = () => ({type: CLEAR_ERRORS});

export const clearSecrets = () => ({type: CLEAR_SECRETS});

export const setStartTime = () => ({type: SET_STARTTIME});

export const clearStartTime = () => ({type: CLEAR_STARTTIME});

export const filterLogs = selection => ({type: FILTER_LOGS, payload: selection});
export const clearLogFilter = () => ({type: CLEAR_LOGFILTER});

export const filterAccounts = selection => ({type: FILTER_ACCOUNTS, payload: selection});
export const clearAccountFilter = () => ({type: CLEAR_ACCOUNTFILTER});

